import { Injectable } from '@angular/core';
import { GenericResponse } from '../business-entities/generic-response';
import { Urls } from './../../../../Autofacets-Core/src/app/utils/urls';
import { DataService } from './../../../../Autofacets-Core/src/app/services/data.service'
import { TechnicalManual } from '../business-entities/technical-manual-model';

@Injectable({
    providedIn: 'root'
})

export class TechnicalManualDataService {
    constructor(private dataProvider: DataService) {
    }

    async getTechnicalManualList(): Promise<GenericResponse<Array<TechnicalManual>>> {
        return this.dataProvider.Get<GenericResponse<Array<TechnicalManual>>>(Urls.GetTechnicalList).toPromise();
    }

    deleteTechnicalMaual(technicalManualId:number){
        return this.dataProvider.Delete<GenericResponse<boolean>>(Urls.DeleteTechnicalManual,technicalManualId).toPromise();
    }

    async getTechnicalManualById(technicalManualId: number): Promise<GenericResponse<TechnicalManual>> {
        return this.dataProvider.Get<GenericResponse<TechnicalManual>>
        (Urls.GetTechnicalManual, technicalManualId).toPromise();
    }

    addTechnicalManual(model : any) : Promise<any> {
        return this.dataProvider.Post<GenericResponse<any>>(Urls.AddtechnicalManual, model).toPromise();
    }

    editTechnicalManual(model:any): Promise<any> {
        return this.dataProvider.Post<GenericResponse<any>>(Urls.EditTechnicalManual, model).toPromise();
    }
    
}